import classNames from "classnames/dedupe";
import React, { forwardRef } from "react";
import { Button } from "../Button";
import { IPayButtonProps } from "./PayButton.interface";

export const PayButton = forwardRef<HTMLButtonElement, IPayButtonProps>(
  ({ text, variant, classes, children, ...button }, ref) => {
    const btnClasses = classNames(classes?.root, {
      "btn-apple": variant === "apple-pay",
      "btn-google": variant === "google-pay",
    });

    return (
      <Button
        ref={ref}
        variant="payment"
        classes={{ root: btnClasses }}
        {...button}
      >
        {text}
        <div data-testid="payment-icon" className={variant} />
      </Button>
    );
  },
);
